 
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY';
export const CLEAR_CART = 'CLEAR_CART';
export const APPLY_DISCOUNT = 'APPLY_DISCOUNT';

export const ADD_TAB = 'ADD_TAB';
export const REMOVE_TAB = 'REMOVE_TAB';
export const SWITCH_TAB = 'SWITCH_TAB';
export const RENAME_TAB = 'RENAME_TAB';

export const SET_PRODUCTS = 'SET_PRODUCTS';
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS';
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';

export const TOGGLE_THEME = 'TOGGLE_THEME';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
export const SET_PO_PREFILL_DATA = 'SET_PO_PREFILL_DATA';
export const CLEAR_PO_PREFILL_DATA = 'CLEAR_PO_PREFILL_DATA';
export const SET_POS_LAYOUT = 'SET_POS_LAYOUT';




 